/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_cloud_logic_custom": [
        {
            "name": "helpEmail",
            "endpoint": "https://ectx283s8a.execute-api.eu-west-1.amazonaws.com/musprod",
            "region": "eu-west-1"
        },
        {
            "name": "zoomAPI",
            "endpoint": "https://3iwd53ix12.execute-api.eu-west-1.amazonaws.com/musprod",
            "region": "eu-west-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://633p7s633zhhhh52lj5atrm2ya.appsync-api.eu-west-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-west-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-hleniavrq5cchks2ie5znl4dqu",
    "aws_cognito_identity_pool_id": "eu-west-1:4f061a32-c08d-46bc-905b-cbaabc712876",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_lHWLlJPO9",
    "aws_user_pools_web_client_id": "dvohfsi49b73ui14g4hnvvq6d",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "smarterplan339b07b1fc8041f2bca722faad9c20ff95806-musprod",
    "aws_user_files_s3_bucket_region": "eu-west-1"
};


export default awsmobile;
